<template>
    <div>
        <h4>Autorizaciones previas</h4>
        <button v-if="isAdminClient" class="btn btn-primary" @click="startSaveAuthorization()"><i class="fa fa-user-plus"></i> Crear nueva autorización</button>
        <button v-if="isAdminClient" class="btn btn-primary" @click="$router.push({ name: 'loadAuthorizations' })"><i class="fa fa-upload"></i> Cargar autorizaciones</button>
        <div class="filters">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="d-flex justify-content-around">
                            <div>
                                <app-form-text-input label="Persona autorizada" v-model="filters.name" />                               
                            </div>
                            <div>
                                <app-form-text-input label="Destino" v-model="filters.destination" />
                            </div>
                            <div>
                                <app-form-select-input
                                    label="Tipo visitante"
                                    :options="visitorTypes"
                                    v-model="filters.visitortype"
                                />
                            </div>
                            <div class="d-flex justify-content-between align-items-end buttons-cell">
                                <button @click="searchPeople" class="btn btn-primary flex-grow-0 flex-shrink-0">
                                    <i class="fa fa-filter"></i> Filtrar</button>
                                <button @click="cancelFilter" class="btn btn-secondary flex-grow-0 flex-shrink-0">
                                    <i class="fa fa-times-circle"></i> Reiniciar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="alert alert-success" v-if="!authorizations.length">
                ¡No hay datos! 
            </div>  
        </div>

        <app-table-authorize-entry-person
            :data="data"
            :on-change-page="onChangePage"
            :start-remove="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up v-if="canCreateAuthorizations" title="Formulario de autorización" id="authorization-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-authorize-entry-person :onSave="onSave"></app-authorize-entry-person>
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('authorization-form.save')"> Guardar</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="authorization-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta autorización?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteAuthorization(selectAuthorization)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>

        </app-pop-up>

        <!-- fin de pop ups -->
        
    </div>   
</template>
<script>
import AuthorizationReposotory from '../../../repositories/authorize.repository';
import vigilanceRepository from '../../../repositories/vigilance.repository';
import AuthorizeEntryPerson from './AuthorizeEntryPerson.vue';
import TableAuthorizeEntryPerson from './TableAuthorizeEntryPerson/TableAuthorizeEntryPerson.vue';
export default {

    components: {
        appAuthorizeEntryPerson: AuthorizeEntryPerson,
        appTableAuthorizeEntryPerson: TableAuthorizeEntryPerson
    },
    data(){
        return{
            authorizations: [],
            selectAuthorization: '',
            filters: {
                destination: '',
                name: '',
                visitortype: ''
            },
            page: 1,
            data: {},
            visitorTypes: [],
            sort: {
                sortBy: 'person.name',
                sortDir: 'asc'
            }
        }
    },
    computed: {
        canCreateAuthorizations() {
            return ['cliente-admin', 'vigilante', 'administrativo'].includes(this.user.profile.slug);
        },
        isAdminClient() {
            return this.user.profile.slug === 'cliente-admin';
        }
    },
    methods: {
        loadAuthorizations(){
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            const ar = Object.assign({}, AuthorizationReposotory);
                ar.loadAuthorizations(this.client.id, filters, this.page)
                .then(data=>{
                    this.data = data;
                    this.authorizations = data.data;
                })
                .catch();
        },
        loadVisitorTypes(){
            const vr = Object.assign({}, vigilanceRepository);
                vr.getVisitorTypes()
                .then(data => this.visitorTypes = data.filter(item => !!item.selectable && item.group === 'peatonal'))
                .catch(error => toastr.error('Ocurrió un error al cagar los tipos de visitante'));
        },
        deleteAuthorization(authorization) {
            const ar = Object.assign({}, AuthorizationReposotory);
            ar
                .deleteAuthorization(authorization.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadAuthorizations();
                        this.$bus.$emit('authorization-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("No se pudo borrar la autorización");
                });
        },
        cleanForm() {
            this.$bus.$emit('authorization-form.clean');
        },
        startSaveAuthorization(){
            this.selectAuthorization = '';
            this.$bus.$emit('authorization-form.open');
        },
        onSave() {
            this.$bus.$emit('authorization-form.close');
            this.loadAuthorizations();
        },
        startRemove(authorization){
            this.selectAuthorization = authorization;
            this.$bus.$emit('authorization-remove.open');
        },
        onChangePage(page){
            this.page = page;
            this.loadAuthorizations();
        },
        searchPeople(){
            this.page = 1;
            this.loadAuthorizations();
        },
        cancelFilter(){
            this.page = 1;
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.loadAuthorizations();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadAuthorizations();
        }

    },

    created(){
        this.loadAuthorizations();
        this.loadVisitorTypes();
    }
    
}
</script>

